export const lensAddresses = {
  accountLens: "0xdeB31DCfDe72abf31b571AfB022840dCB5D73FCf",
  eulerEarnVaultLens: "0x06019976448Fadc735616f42ED6D02a098561A07",
  irmLens: "0x294F6f07752Afb3470c5c2B86271C43BB3Df6284",
  oracleLens: "0xFf1177B9e483b21820052dF2B39DebB9584855d1",
  utilsLens: "0x64aD120b92d5562d72Af42eE39B82c56fD23d206",
  vaultLens: "0xd20E9D6cfa0431aC306cC9906896a7BC0BE0Db64",
} as const
